import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function apiErrorDetail(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => {
    const field = Array.isArray(x?.loc) && x.loc.length ? x.loc[x.loc.length - 1] : null;
    const msg = String(x?.msg || "").replace(/field required/i, "is required");
    return field ? `${field}: ${msg}` : msg;
  }).join(", ");
  return String(d);
}

export default api;
